import { render, staticRenderFns } from "./newYear.vue?vue&type=template&id=74e813a8&scoped=true&"
import script from "./newYear.vue?vue&type=script&lang=js&"
export * from "./newYear.vue?vue&type=script&lang=js&"
import style0 from "./newYear.vue?vue&type=style&index=0&id=74e813a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e813a8",
  null
  
)

export default component.exports